import { EyeOutlined } from '@ant-design/icons';
import { Avatar, Popover, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { TicketActivity, TicketActivityType, TicketActivityTypeMap } from '..';
import ProfilePicture from '../../ProfilePicture';

const visitingStyle = { backgroundColor: '#936BB6' };
const editingStyle = { ...visitingStyle, border: '2px solid #f50000' };
const idleStyle = { backgroundColor: '#CCB8DE' };

const avatarStyleMap = {
    [TicketActivityTypeMap.editing]: editingStyle,
    [TicketActivityTypeMap.visiting]: visitingStyle,
    [TicketActivityTypeMap.idle]: idleStyle
};

function ActivityAvatar({ email, type }: { email: string; type: TicketActivityType }) {
    const { t } = useTranslation('tickets');

    return (
        <Tooltip
            title={
                <>
                    <strong>{email}</strong>
                    <br />
                    {t(`activity.${type}`)}
                </>
            }
        >
            <ProfilePicture style={avatarStyleMap[type]}>{email[0]?.toUpperCase()}</ProfilePicture>
        </Tooltip>
    );
}

function getContent(activity: TicketActivity) {
    return (
        <Avatar.Group>
            {activity.editing.map((email) => (
                <ActivityAvatar key={email} email={email} type={TicketActivityTypeMap.editing} />
            ))}
            {activity.visiting.map((email) => (
                <ActivityAvatar key={email} email={email} type={TicketActivityTypeMap.visiting} />
            ))}
            {activity.idle.map((email) => (
                <ActivityAvatar key={email} email={email} type={TicketActivityTypeMap.idle} />
            ))}
        </Avatar.Group>
    );
}
function EyePopover({ activity }: { activity: TicketActivity }) {
    const { t } = useTranslation('tickets');
    return (
        <Popover content={getContent(activity)} title={t('activity.text')}>
            <EyeOutlined style={{ margin: 0 }} />
        </Popover>
    );
}

interface StaticActivityIndicatorProps {
    activity: TicketActivity;
    showable?: boolean;
}
export default function StaticActivityIndicator({ showable = false, activity }: StaticActivityIndicatorProps) {
    if (!activity?.hasActivity) return null;
    return showable ? <EyePopover activity={activity} /> : <EyeOutlined style={{ margin: 0 }} />;
}
